'use strict';
module.exports = Math.log2 || function (x) {
	return Math.log(x) * Math.LOG2E;
};



//////////////////
// WEBPACK FOOTER
// ./~/math-log2/index.js
// module id = 631
// module chunks = 0